const BAR_HIDDEN_SESSION_KEY = 'Inspiretec.PromoStripHidden';
const BAR_HIDDEN_CLASS = 'hide-promo-strip';

export default class {
  constructor(context) {
    this.context = context;
    this.closeButton = context.querySelector('[data-close-promo-strip]');
    this.init();
  }

  init() {
    if (this.closeButton) {
        this.closeButton.addEventListener('click', this.handleCloseClick);
        this.closeButton.addEventListener('keydown', this.handleKeyDown);
    }
  }

  hidePromoStrip = () => {
    this.closeButton.removeEventListener('click', this.handleCloseClick);
    this.closeButton.removeEventListener('keydown', this.handleKeyDown);

    /**
     * We need to add a class onto the document element so we can avoid
     * a layout shift when we load the visibility status from session
     * storage. This is done in the Default.cshtml templates.
     */
    document.documentElement.classList.add(BAR_HIDDEN_CLASS);
    sessionStorage.setItem(BAR_HIDDEN_SESSION_KEY, true);
  }

  handleCloseClick = () => {
    this.hidePromoStrip();
  }

  handleKeyDown = (event) => {
    if (event.code === 'Enter' || event.code === 'Space') {
        this.hidePromoStrip();
    }
  }
}
